import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Box, styled, Switch, InputAdornment } from "@mui/material";
import { useEffect } from "react";
import UploadFileButton from "../../UploadFileButton/UploadFileButton";

const EditableFileInput = ({
  inputId,
  propsInitialValue,
  editMode,
  inputMode,
  adornment,
  setParentValue,
}) => {
  const [value, setValue] = useState(null);
  const [initialValue, setInitialValue] = useState(propsInitialValue);

  // has been focused in edit mode
  const [touched, setTouched] = useState(false);

  // callback from the parent
  const handleInputChange = (e) => {
    setValue(e.target.files[0]);
    setParentValue(inputId, value);
  };

  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item xs>
        {editMode && (
          <UploadFileButton file={value} handleFileChange={handleInputChange} />
        )}
      </Grid>
    </Grid>
  );
};

export default EditableFileInput;
